import White_logo from '../../../assets/img/logo/white-logo.png'
import logo from '../../../assets/img/logo/logo.png'
import product_images from '../../../assets/img/product-images/01.png'
import banner1 from '../../../assets/img/hero-bg/banner1.png'
import Chat_astro from '../../../assets/img/category/Chat-astro.png'
import chat_numerology from '../../../assets/img/category/chat-numerology.png'
import counsellor from '../../../assets/img/category/counsellor.png'
import festival_year from '../../../assets/img/category/festival-year.png'
import punchang from '../../../assets/img/category/punchang.png'
import product_images1 from '../../../assets/img/product-images/01.png'
import product_images2 from '../../../assets/img/product-images/02.png'
import product_images3 from '../../../assets/img/product-images/03.png'
import product_images4 from '../../../assets/img/product-images/04.png'
import talk_to_premium_astro_banner from '../../../assets/img/banner/banner1.png'
import sales_banner from '../../../assets/img/banner/banner2.png'
import call_icon from '../../../assets/img/icons/call-icon.png'
import chat_icon from '../../../assets/img/icons/chat-icon.png'
import report_icon from '../../../assets/img/icons/report-icon.png'
import astro1 from '../../../assets/img/astro/1.png'
import astro3 from '../../../assets/img/astro/3.png'
import astro2 from '../../../assets/img/astro/2.png'
import product_images_5 from '../../../assets/img/product-images/05.png'
import custom_designs1 from '../../../assets/img/category/custom-designs.png'
import custom_designs2 from '../../../assets/img/category/custom-designs2.png'
import custom_designs3 from '../../../assets/img/category/custom-designs3.png'
import custom_designs4 from '../../../assets/img/category/custom-designs4.png'
import custom_designs5 from '../../../assets/img/category/custom-designs5.png'
import custom_video1 from '../../../assets/img/video/video.mp4'
import collection1 from '../../../assets/img/collection/1.png'
import user1 from '../../../assets/img/user/1.jpg'
import user5 from '../../../assets/img/user/5.jpg'
import user4 from '../../../assets/img/user/4.jpg'
import user3 from '../../../assets/img/user/3.jpg'
import user2 from '../../../assets/img/user/2.jpg'
import user7 from '../../../assets/img/user/7.png'
import expert_bg from '../../../assets/img/bg/expert-bg.png'
import about from '../../../assets/img/astro/about.png'
import faq from '../../../assets/img/astro/faq.png'
import blog1 from '../../../assets/img/blog/1.png'
import blog2 from '../../../assets/img/blog/2.png'
import blog3 from '../../../assets/img/blog/3.png'
import blog4 from '../../../assets/img/blog/4.png'
import trusted_user_0 from '../../../assets/img/trusted-user/0.png'
import private_confidential from '../../../assets/img/icons/private-confidential.svg'
import verified_astrologers from '../../../assets/img/icons/verified-astrologers.svg'
import secure_payments from '../../../assets/img/icons/secure-payments.svg'
import headphones_head from '../../../assets/img/icons/headphones_head.svg'
import email_envelope_icon from '../../../assets/img/icons/email_envelope_icon.svg'
import android from '../../../assets/img/app/android.png'
import apple from '../../../assets/img/app/apple.png'
import payment from '../../../assets/img/hero-bg/payment.png'
import user_profile from '../../../assets/img/astro/3.png'
import user_logo from '../../../assets/img/user/user.png'
import product_bg from '../../../assets/img/bg/product-bg.png'
import product_details_1 from '../../../assets/img/product-images/09.jpg'
import product_details_2 from '../../../assets/img/product-images/10.jpg'
import free_kundli from '../../../assets/img/astro/free-kundli.png'
import janam_kundli from '../../../assets/img/astro/janam-kundli.png'
import astrologer_banner from '../../../assets/img/astro/astrologer-banner.png'
import free_kundli2 from '../../../assets/img/astro/free-kundli2.png'
import ku_ma from '../../../assets/img/astro/ku-ma.png'
import panchange from '../../../assets/img/astro/panchange.png'
import daily_horoscope from '../../../assets/img/astro/daily-horoscope.png'
import love_calculater from '../../../assets/img/astro/love-calculater.png'
import daily_horoscope2 from '../../../assets/img/astro/daily-horoscope2.jpg'
import Scorpio from '../../../assets/img/astro/Scorpio.png'
import Libra from '../../../assets/img/astro/Libra.png'
import Virgo from '../../../assets/img/astro/Virgo.png'
import leo from '../../../assets/img/astro/leo.png'
import Cancer from '../../../assets/img/astro/Cancer.png'
import Gemini from '../../../assets/img/astro/Gemini.png'
import Taurus from '../../../assets/img/astro/Taurus.png'
import Aries from '../../../assets/img/astro/Aries.png'
import HomeNewsletter from '../../../assets/img/astro/mall-product2.png'

import panchange2 from '../../../assets/img/astro/panchange2.png'
import love_calendar from '../../../assets/img/astro/love-calendar.svg'
import love_banner from '../../../assets/img/astro/love-banner.png'
import Piscis from '../../../assets/img/astro/Piscis.png'
import Aquarius from '../../../assets/img/astro/Aquarius.png'
import Capricorn from '../../../assets/img/astro/Capricorn.png'
import Sagitarius from '../../../assets/img/astro/Sagitarius.png'
import boys_icon from '../../../assets/img/astro/boys-icon.png'
import girl_icon from '../../../assets/img/astro/girl-icon.png'
import celebrity_1 from '../../../assets/img/celebrity/celebrity-1.png'
import celebrity_2 from '../../../assets/img/celebrity/celebrity-2.png'
import diamond_icon from '../../../assets/img/icons/diamond-icon.svg'
import Ring_icon from '../../../assets/img/icons/ring-icon.svg'
import pendant_icon from '../../../assets/img/icons/pendant-icon.svg'
import bracelet_icon from '../../../assets/img/icons/bracelet-icon.svg'
import paypal from '../../../assets/img/icons/paypal.png'
import creditcard from '../../../assets/img/icons/creditcard.png'
import netbanking from '../../../assets/img/icons/netbanking.png'
import paytm from '../../../assets/img/icons/paytm.png'
import phonepe from '../../../assets/img/icons/phonepe.png'
import skills_icon from '../../../assets/img/icons/skills-icon.svg'
import gallery_icon from '../../../assets/img/icons/gallery_icon.png'
import delete_icon from '../../../assets/img/icons/delete-icon.png'
import wish_list from '../../../assets/img/icons/wish_list.png'
import knowMoreArrow from '../../../assets/img/icons/know-more-arrow.svg'



const Common_Images_Transport = {
    White_logo,
    logo,
    product_images,
    banner1,
    punchang,
    festival_year,
    counsellor,
    chat_numerology,
    Chat_astro,
    product_images1,
    product_images2,
    product_images3,
    product_images4,
    talk_to_premium_astro_banner,
    sales_banner,
    call_icon,
    chat_icon,
    report_icon,
    astro1,
    astro3,
    astro2,
    HomeNewsletter,
    product_images_5,
    custom_designs1,
    custom_designs2,
    custom_designs3,
    custom_designs4,
    custom_designs5,
    custom_video1,
    collection1,
    user1,
    user7,
    expert_bg,
    about,
    faq,
    blog1,
    blog2,
    blog3,
    blog4,
    trusted_user_0,
    private_confidential,
    verified_astrologers,
    secure_payments,
    headphones_head,
    email_envelope_icon,
    android,
    apple,
    payment,
    user_profile,
    user_logo,
    product_bg,
    product_details_1,
    product_details_2,
    free_kundli,
    janam_kundli,
    astrologer_banner,
    free_kundli2,
    love_calculater,
    daily_horoscope,
    panchange,
    ku_ma,
    daily_horoscope2,
    Aries,
    Taurus,
    Scorpio,
    Libra,
    Virgo,
    leo,
    Cancer,
    Gemini,
    panchange2,
    love_calendar,
    love_banner,
    Sagitarius,
    Capricorn,
    Aquarius,
    Piscis,
    girl_icon,
    boys_icon,
    celebrity_1,
    celebrity_2,
    bracelet_icon,
    pendant_icon,
    Ring_icon,
    diamond_icon,
    paypal,
    creditcard,
    netbanking,
    paytm,
    phonepe,
    user2,
    user3,
    user4,
    user5,
    skills_icon,
    gallery_icon,
    delete_icon,
    wish_list,
    knowMoreArrow,
};

export default Common_Images_Transport;
